module.exports = "img/flags/GQ.08498f9.png";